import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Reassigner from './view';

const ReassignerModule = ({ match }) => {
  return (
    <Switch>
      <Route exact path={match.url} component={Reassigner} />
    </Switch>
  );
};

export default ReassignerModule;
